
'use strict';

/* ── Sticky header ──────────────────────────────────────────────────────────── */
const hdr = document.querySelector('.site-header');
if (hdr) {
  const tick = () => hdr.classList.toggle('scrolled', window.scrollY > 10);
  window.addEventListener('scroll', tick, {passive: true});
  tick();
}

/* ── Mobile nav ─────────────────────────────────────────────────────────────── */
const burger = document.querySelector('.burger');
const mNav   = document.querySelector('.mobile-nav');
if (burger && mNav) {
  const lock = open => { document.body.style.overflow = open ? 'hidden' : ''; };
  burger.addEventListener('click', () => { mNav.classList.toggle('open'); lock(mNav.classList.contains('open')); });
  mNav.querySelectorAll('a').forEach(a => a.addEventListener('click', () => { mNav.classList.remove('open'); lock(false); }));
}

/* ── Scroll reveal ──────────────────────────────────────────────────────────── */
const ro = new IntersectionObserver(entries => {
  entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); ro.unobserve(e.target); } });
}, {threshold: 0.1});
document.querySelectorAll('.reveal').forEach(el => ro.observe(el));

/* ── Cart ───────────────────────────────────────────────────────────────────── */
const drawer     = document.getElementById('cart-drawer');
const drawerItems = document.getElementById('cart-drawer__items');
const drawerTotal = document.getElementById('cart-drawer__total');
const countEls   = document.querySelectorAll('.cart-btn__count');

const money = c => '$' + (c / 100).toFixed(2);

async function getCart() {
  return fetch('/cart.js').then(r => r.json());
}

async function syncCart() {
  const cart = await getCart();
  countEls.forEach(el => {
    el.textContent = cart.item_count;
    el.classList.toggle('visible', cart.item_count > 0);
  });
  if (!drawerItems) return;
  if (cart.item_count === 0) {
    drawerItems.innerHTML = '<div class="cart-empty"><strong>Your cart is empty</strong>Add something cinematic.</div>';
    if (drawerTotal) drawerTotal.textContent = money(0);
    return;
  }
  drawerItems.innerHTML = cart.items.map(i => `
    <div class="cart-item">
      ${i.image ? `<img class="cart-item__img" src="${i.image}" alt="${i.title}">` : '<div class="cart-item__img"></div>'}
      <div>
        <div class="cart-item__name">${i.product_title}</div>
        <div class="cart-item__price">${i.variant_title !== 'Default Title' && i.variant_title ? i.variant_title + ' · ' : ''}${money(i.final_line_price)}</div>
      </div>
    </div>
  `).join('');
  if (drawerTotal) drawerTotal.textContent = money(cart.total_price);
}

function openDrawer() {
  if (!drawer) return;
  drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  syncCart();
}
function closeDrawer() {
  if (!drawer) return;
  drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

document.querySelector('.cart-drawer__close')?.addEventListener('click', closeDrawer);
document.querySelector('.cart-drawer__overlay')?.addEventListener('click', closeDrawer);
document.addEventListener('click', e => { if (e.target.closest('[data-open-cart]')) openDrawer(); });

/* ── Add to cart ────────────────────────────────────────────────────────────── */
document.addEventListener('submit', async e => {
  if (!e.target.matches('[data-atc-form]')) return;
  e.preventDefault();
  const form = e.target;
  const btn = form.querySelector('[data-atc-btn]');
  const orig = btn?.textContent;
  if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }
  try {
    const r = await fetch('/cart/add.js', {method: 'POST', body: new FormData(form)});
    if (r.ok) { await syncCart(); openDrawer(); }
    else { const d = await r.json(); alert(d.description || 'Could not add to cart.'); }
  } catch {}
  if (btn) { btn.textContent = orig; btn.disabled = false; }
});

/* ── Variant selector ───────────────────────────────────────────────────────── */
document.addEventListener('click', e => {
  const btn = e.target.closest('.variant-btn');
  if (!btn) return;
  btn.closest('.variant-btns').querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  const form = btn.closest('[data-atc-form]');
  if (form) { const id = form.querySelector('[name="id"]'); if (id) id.value = btn.dataset.vid; }
});

/* ── Init ───────────────────────────────────────────────────────────────────── */
syncCart();

